// extracted by mini-css-extract-plugin
module.exports = {"paymentsNone":"internal-transfers-list-table_paymentsNone__1ReMc","resultSpan":"internal-transfers-list-table_resultSpan__1-kwJ"};